import React, { useEffect } from 'react';


interface IComponentProps {
  editFn?: (params: any) => void;
  imgUrl?: string
  name?: string
}
const DidiSelectionCommonColumn: React.FC<IComponentProps> = (props) => {
  const { imgUrl, name, editFn } = props
  const style: React.CSSProperties = {
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: '22px',
    color: 'rgba(0, 0, 0, 0.88)',
    margin: '0 4px',
  }

  return (
    <div style={{display: 'flex', alignItems: 'center', flexDirection: 'row'}}>
      {
        imgUrl ? <img style={{ width: '16px', height: '16px' }} src={imgUrl} alt=""/> : null
      }
      <div style={style}>{name}</div>
      {
        editFn ? <img
          src='https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/bianji-icon.png'
          style={{ width: '16px', height: '16px' }} onClick={editFn} alt=""/> : null
      }
    </div>
  );
};

export default DidiSelectionCommonColumn;
